@for (badge of badges(); track badge.label) {
  <procure-tag [tooltip]="badge.tooltip">{{ badge.label }}</procure-tag>
}
